// Any element with data-swirl-toggle opens/closes the swirl panels. Give it the
// section's id (data-swirl-toggle="swirlslider-<section id>") to target one, or
// leave it empty to target the nav overlay version (or the first swirl section on
// the page if there's no overlay) — that's how the header's Products nav item works.
(function () {
  if (window.fcSwirlToggleBound) return;
  window.fcSwirlToggleBound = true;

  function findSection(targetId) {
    if (targetId) return document.getElementById(targetId);
    return document.querySelector('.fc-swirl-slider.fcswirl-overlay-mode') || document.querySelector('.fc-swirl-slider');
  }

  function setOpen(section, open) {
    section.classList.toggle('fcswirl-open', open);

    document.querySelectorAll('[data-swirl-toggle]').forEach(function (el) {
      var elTarget = el.getAttribute('data-swirl-toggle');
      if (findSection(elTarget) === section) {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
        el.classList.toggle('fcswirl-trigger-active', open);
      }
    });

    // Opening the nav overlay closes the header's other dropdowns (mobile menu,
    // Shop dropdown) so only one panel slides down at a time.
    if (open && section.classList.contains('fcswirl-overlay-mode')) {
      var fullnav = document.querySelector('.fullnav');
      if (fullnav) fullnav.classList.remove('fullnav-mobile-active');
      var shopDD = document.querySelector('.shop-dd');
      if (shopDD) shopDD.classList.remove('shop-dd-active');
    }
  }

  function closeOverlays() {
    document.querySelectorAll('.fc-swirl-slider.fcswirl-overlay-mode.fcswirl-open').forEach(function (s) {
      setOpen(s, false);
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-swirl-toggle]');
    if (trigger) {
      e.preventDefault();
      var section = findSection(trigger.getAttribute('data-swirl-toggle'));
      if (section) setOpen(section, !section.classList.contains('fcswirl-open'));
      return;
    }

    // Click outside an open nav overlay closes it.
    if (!e.target.closest('.fc-swirl-slider.fcswirl-overlay-mode')) closeOverlays();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOverlays();
  });

  // Theme editor: open the overlay while its section (or a panel block) is selected.
  document.addEventListener('shopify:section:select', function (e) {
    var section = e.target.querySelector('.fc-swirl-slider.fcswirl-overlay-mode');
    if (section) setOpen(section, true);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var section = e.target.querySelector('.fc-swirl-slider.fcswirl-overlay-mode');
    if (section) setOpen(section, false);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('.fc-swirl-slider.fcswirl-overlay-mode');
    if (section) setOpen(section, true);
  });
})();
